<form class="locality-selector" [formGroup]="localitySelectorFG">
    <mat-form-field class="garantor-form-field provincia" appearance="outline">
        <mat-label>Provincia</mat-label>
        <mat-select formControlName="province" (ngModelChange)="updateProvince($event)">
            <mat-option *ngFor="let province of provinces" [value]="province.codigo">
                {{ province.descripcion }}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="localitySelectorFG.controls['province'].hasError('required')">
            Por favor ingrese la provincia
        </mat-error>
    </mat-form-field>
    <mat-form-field class="garantor-form-field municipio" appearance="outline">
        <mat-label>Municipio</mat-label>
        <mat-select formControlName="municipality" (ngModelChange)="updateMunicipality($event)">
            <mat-option *ngFor="let municipality of municipalities" [value]="municipality.codigo">
                {{ municipality.descripcion }}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="localitySelectorFG.controls['municipality'].hasError('required')">
            Por favor ingrese el municipio
        </mat-error>
    </mat-form-field>
    <mat-form-field class="garantor-form-field localidad" appearance="outline">
        <mat-label>Localidad</mat-label>
        <mat-select formControlName="locality" (ngModelChange)="updateLocality($event)">
            <mat-option *ngFor="let locality of localities" [value]="locality.codigo">
                {{ locality.descripcion }}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="localitySelectorFG.controls['locality'].hasError('required')">
            Por favor ingrese la localidad
        </mat-error>
    </mat-form-field>
</form>
